import { useCallback, useEffect, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import { AiOutlineClose, AiOutlineReload, AiOutlineUpload } from 'react-icons/ai'
import { BsBookmark, BsFillCloudUploadFill } from 'react-icons/bs'
import { toast } from 'react-toastify'
import * as XLSX from 'xlsx'
import { ButtonSubmit } from '../../../../GlobalStyle'
import { useAddFixedExpenses, useAddMethodsSales, useAddProduct } from '../../../../hooks/mutations'
import Base from '../index'
import { ContentModal } from '../style'
import { Actions, Close, ListFiles, Zone } from './style'

const ModalImport = ({ data, type }) => {
  const { fixed, variable } = data

  const validate = (list) => {
    if (type == 'products') return true
    const isValid = list.every((item) => {
      return (
        typeof item.NOME === 'string' &&
        typeof item.MES1 === 'number' &&
        typeof item.MES2 === 'number' &&
        typeof item.MES3 === 'number'
      )
    })
    return isValid
  }
  const notInList = (name, list) => {
    const resultado = list.some((objeto) => objeto.nome === name)
    return !resultado
  }

  const [items, setItems] = useState([])

  const { mutate: addFixedExpense } = useAddFixedExpenses()
  const { mutate: addVariableExpense } = useAddMethodsSales()
  const { mutate: addProduct } = useAddProduct()

  const readExcel = (files) => {
    files.map((file, index) => {
      const promise = new Promise((resolve, reject) => {
        const fileReader = new FileReader()
        fileReader.readAsArrayBuffer(file)

        fileReader.onload = (e) => {
          const bufferArray = e.target.result

          const wb = XLSX.read(bufferArray, { type: 'buffer' })

          const wsname = wb.SheetNames[0]

          const ws = wb.Sheets[wsname]

          const data = XLSX.utils.sheet_to_json(ws)

          resolve(data)
        }

        fileReader.onerror = (error) => {
          reject(error)
        }
      })

      const currentMonthIndex = fixed.partida_mes
      promise.then((item) => {
        if (validate(item)) {
          item.map((i) => {
            switch (type) {
              case 'fixed':
                if (notInList(i.NOME, fixed.data) && validate(item)) {
                  addFixedExpense({
                    nome: i.NOME,
                    meses: [i.MES1, i.MES2, i.MES3],
                    inicio: currentMonthIndex,
                  })
                }
                break

              case 'variable':
                if (notInList(i.NOME, variable)) {
                  addVariableExpense({
                    nome: i.NOME,
                    meses: [i.MES1, i.MES2, i.MES3],
                    inicio: currentMonthIndex,
                  })
                }
                break

              case 'products':
                // eslint-disable-next-line no-case-declarations
                const obj = {
                  nome: i.NOME,
                  quantidade: 1,
                  preco_custo: i.CUSTO,
                  preco_venda: i.VENDA,
                  components: [],
                  lucro: i.LUCRO,
                  unidade: 'UNI',
                  codigo_barras: i.CODIGO,
                  plataformas: [
                    {
                      id: 1,
                      preco_zero: i.ZERO,
                      preco_venda: i.VENDA,
                    },
                  ],
                }
                addProduct(obj)
                break

              default:
                break
            }
          })
          toast.success('Importado com sucesso')
          deleteFile(index)
        } else toast.error('Campos faltando ou incorretos, verifique o documento')
      })
    })
  }

  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      setItems((data) => [...data, ...acceptedFiles.map((x) => x)])
    }
  }, [])
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop })
  useEffect(() => {
    console.log(items)
  }, [items])

  const deleteFile = (index) => {
    setItems((prevItems) => prevItems.filter((item, i) => i !== index))
  }

  const files = items.map((file, index) => (
    <li key={file.path}>
      <span>
        <BsBookmark />
        {file.path}
        <Close onClick={() => deleteFile(index)}>
          <AiOutlineClose />
        </Close>
      </span>
    </li>
  ))
  return (
    <Base title={'Upload de dados'} width={'70%'} height={'75%'}>
      <ContentModal>
        <Zone isDragActive={isDragActive} {...getRootProps({ className: 'dropzone' })}>
          <div>
            <p>
              <BsFillCloudUploadFill />
            </p>
            <input {...getInputProps()} />
            <h3>Arraste seu arquivo aqui ou</h3>
            <h3>Clique para fazer upload</h3>
            <p>São aceitos arquivos de formato(s): .xls, .xlsx</p>
          </div>
        </Zone>
      </ContentModal>
      <ListFiles>
        <ul>{files}</ul>
      </ListFiles>

      <Actions>
        <ButtonSubmit medium width={'auto'} invert>
          {' '}
          <AiOutlineUpload /> Baixar planilha modelo
        </ButtonSubmit>
        <ButtonSubmit medium width={'auto'} onClick={() => readExcel(items)}>
          <AiOutlineReload /> Atualizar
        </ButtonSubmit>
      </Actions>
    </Base>
  )
}
export default ModalImport
